(function () {
    'use strict';

    angular
        .module('franchisee.components')
        .controller('PeopleListController', PeopleListController)

    /** @ngInject */
    function PeopleListController($q, $rootScope, $scope, UtilHelper, ResponsibilityService, PersonService, AuthenticationService,
        LoadingHelper, SYSTEM_MODULES, DATA_EVENTS) {
        const vm = this;

        let isTableSearch = false;
        let forcePaginationReset = false;

        vm.isSearchDisabled = () => {
            if (vm.selectedResponsibility || (vm.selectedSearchField && vm.searchText))
                return false;

            return true;
        }

        vm.isClearDisabled = () => {
            if (isTableSearch)
                return false;

            if (vm.selectedResponsibility || vm.selectedSearchField || vm.searchText)
                return false;

            return true;
        }

        vm.doSearch = (event, isFromButton) => {
            if ((event && event.keyCode == 13) || isFromButton) {
                forcePaginationReset = true;

                vm.tableCallServer();
            }
        }

        vm.clearSearch = () => {
            vm.selectedResponsibility = null;
            vm.selectedSearchField = null;
            vm.searchText = null;

            if (isTableSearch)
                vm.tableCallServer();

            isTableSearch = false;
        }

        vm.tableCallServer = (tableState, stCtrl) => {
            if (!vm.stCtrl && stCtrl)
                vm.stCtrl = stCtrl;

            if (!tableState && vm.stCtrl) {
                vm.stCtrl.pipe();
                return;
            }

            if (vm.isFirstCall)
                return;

            vm.isLoading = true;

            if (forcePaginationReset) {
                tableState.pagination.start = 0;
                forcePaginationReset = false;
            }

            const pagination = tableState.pagination;
            const start = pagination.start || 0;
            const number = pagination.number || 10;

            getPeople(start, number, tableState);
        }

        vm.orderPersonResponsibilities = personCompanies => {
            let filteredPersonCompanies = [];

            for (let index = 0; index < personCompanies.length; index++) {
                const personCompany = personCompanies[index];
                let foundFPC = filteredPersonCompanies.find(fpc => (fpc.ResponsibilityId == personCompany.ResponsibilityId));

                //The logged user can only see the data from the selected user
                if (vm.loggedUserData.UnitId != personCompany.UnitId) continue;

                if (foundFPC) {
                    foundFPC.Companies.push(personCompany.Company)
                } else {
                    filteredPersonCompanies.push({
                        ResponsibilityId: personCompany.ResponsibilityId,
                        Responsibility: personCompany.Responsibility,
                        Companies: [personCompany.Company]
                    })
                }
            }

            return filteredPersonCompanies;
        }

        let removeWatchUnit = $rootScope.$on(DATA_EVENTS.SELECTED_COMPANY_CHANGE, () => {
            initVars();

            vm.doSearch(null, true);
        })

        $scope.$on('$destroy', () => {
            removeWatchUnit();
        })

        init();

        function getPeople(skip, perPage, tableState) {
            let parameters = prepareParameters(skip, perPage, tableState);

            PersonService
                .getByParameters(parameters)
                .then(success => {
                    vm.people = success.Registers;
                    tableState.pagination.numberOfPages = success.NumberOfPages;

                    vm.isLoading = false;
                }, error => {
                    vm.companies = null;
                    vm.isLoading = false;
                    UtilHelper.errorCallback(error);
                })
        }

        function getResponsibilities() {
            return ResponsibilityService
                .getAll()
                .then(success => {
                    vm.responsibilities = success.Registers;
                }, error => {
                    UtilHelper.errorCallback(error);
                    LoadingHelper.stopLoading('.custom-filters');
                })
        }

        function prepareParameters(skip, perPage, tableState) {
            let params = {
                Skip: skip,
                PerPage: perPage,
                OrderBy: 'Name',
                OrderDescending: false,
                CompanyId: vm.loggedUserData.Company.Id
            }

            if (vm.selectedResponsibility || vm.selectedUnit || (vm.selectedSearchField && vm.searchText))
                isTableSearch = true;

            if (vm.selectedResponsibility)
                params.ResponsibilityId = vm.selectedResponsibility.Id;

            if (tableState.sort.predicate) {
                params.OrderBy = tableState.sort.predicate;
                params.OrderDescending = tableState.sort.reverse;
            }

            if (vm.selectedSearchField && vm.searchText) {
                params.SearchField = vm.selectedSearchField.Value;
                params.SearchQuery = vm.searchText;
            }

            return params;
        }

        function initVars() {
            vm.loggedUserData = AuthenticationService.getUser();
            vm.canUserHandlePerson = AuthenticationService.getCompanyDataByPermissionGroupAndModuleId(vm.loggedUserData.PermissionGroup.Id, SYSTEM_MODULES.FRANCHISEE_PEOPLE).length > 0;
            vm.selectedResponsibility;
            vm.selectedPermissionGroup;
            vm.selectedSearchField;
            vm.searchText;
            vm.isLoading = true;

            vm.searchFields = [{
                Value: 'Document',
                Description: 'Documento'
            }, {
                Value: 'Name',
                Description: 'Nome'
            }, {
                Value: 'Email',
                Description: 'E-mail'
            }];
        }

        function init() {
            initVars();

            LoadingHelper.startLoading('.custom-filters');

            $q.all([getResponsibilities()])
                .then(() => {
                    LoadingHelper.stopLoading('.custom-filters');
                })
        }
    }
}());